import PropTypes from 'prop-types'
import React from 'react'

import Box from '@mui/material/Box'

const Icons = ({ changedCompared, floorSpaceDecreased, floorSpaceIncreased, promotion }) => (
  <>
    {changedCompared && <Box className="icon edit-icon" />}
    {promotion && <Box className="icon promotion-icon" />}
    {floorSpaceIncreased && <Box className="icon surface-increased-icon" />}
    {floorSpaceDecreased && <Box className="icon surface-decrease-icon" />}
  </>
)

Icons.propTypes = {
  changedCompared: PropTypes.bool,
  floorSpaceDecreased: PropTypes.bool,
  floorSpaceIncreased: PropTypes.bool,
  promotion: PropTypes.bool,
}

export default Icons
